export const ToolEngineEnum = Object.freeze({
	FORM: "formEngine",
	ITEM_LIST: "itemListEngine",
	TRACKER: "trackerEngine",
	STAGED_WORKSHEET: "stagedWorksheetEngine",
	DOCUMENT: "documentEngine",
	GRAPH: "graphEngine",
	TIMELINE: "timelineEngine",
	CANVAS_TIMELINE: "canvasTimelineEngine",
	COMPOSITION: "compositionEngine",
	EXPERIMENT: "experimentEngine",
	HIERARCHY: "hierarchyEngine",
	GAME: "gameEngine",
	DATA_VIEW: "dataViewEngine",
})
